import { useHistory } from 'react-router-dom';
import { useCallback, useState } from 'react';
import { ROUTES } from 'config';
import { SearchResultEntity, useSearchResults } from 'store/search';
import { useDebouncedCallback } from 'use-debounce';

export const useGlobalSearch = () => {
  const history = useHistory();

  const [searchInputValue, setSearchInputValue] = useState('');
  const [searchQuery, setSearhQuery] = useState('');

  const { data: searchResults, isLoading } = useSearchResults(searchQuery);

  const debouncedSearch = useDebouncedCallback(setSearhQuery, 300);

  const search = (value: string) => {
    setSearchInputValue(value);
    debouncedSearch(value);
  };

  const clearSearch = useCallback(() => {
    setSearhQuery('');
    setSearchInputValue('');
  }, []);

  const handleSearchItemClick = useCallback(
    (entityType: SearchResultEntity, entityId: string) => {
      clearSearch();
      switch (entityType) {
        case 'benefitPlan':
          history.push(ROUTES.benefits.details.replace(':id', entityId));
          break;
        case 'employee':
          history.push(ROUTES.employees.details.replace(':id', entityId));
          break;
        case 'admin':
          history.push(ROUTES.administrators.details.replace(':id', entityId));
          break;
        case 'news':
          history.push('/');
          break;
        case 'employeeGroup':
          history.push(ROUTES.employeeGroups.details.replace(':id', entityId));
          break;
      }
    },
    [clearSearch, history],
  );

  return {
    loading: isLoading,
    search,
    results: searchResults?.items,
    searchQuery,
    searchInputValue,
    clearSearch,
    handleSearchItemClick,
  };
};
